import { render, staticRenderFns } from "./CadriDetailPage.vue?vue&type=template&id=6ae9f764&scoped=true"
import script from "./CadriDetailPage.vue?vue&type=script&lang=js"
export * from "./CadriDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CadriDetailPage.vue?vue&type=style&index=0&id=6ae9f764&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae9f764",
  null
  
)

export default component.exports